import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { ChevronRight } from 'lucide-react'
import { Link, LinkProps } from 'react-router-dom'

interface Props extends Pick<LinkProps, 'to'>, IconButtonProps {}

const Component = ({ to, ...props }: Props) => {
  return (
    <Tooltip label="Ir">
      <IconButton
        as={Link}
        to={to}
        colorScheme="primary"
        icon={<Icon as={ChevronRight} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
